import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const ContentSectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 2),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 2),
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4, 3),
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 4),
  },
}));

export const LastUpdated = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.accent,
  fontWeight: 500,
  marginBottom: theme.spacing(2),
  textAlign: 'right',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.primary.accent,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  borderBottom: `2px solid ${alpha(theme.palette.primary.light, 0.3)}`,
  paddingBottom: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
    marginBottom: theme.spacing(1.5),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.1rem',
    marginBottom: theme.spacing(1),
  },
}));

export const SectionContent = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  lineHeight: 1.7,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    lineHeight: 1.6,
  },
}));

export const SubsectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

export const SubsectionText = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  lineHeight: 1.6,
  color: theme.palette.text.secondary,
  marginLeft: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
}));

export const ContactInfo = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ContactItem = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  lineHeight: 1.6,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  '&:last-child': {
    marginBottom: theme.spacing(2),
  },
}));

export const AddressBlock = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.grey[200]}`,
  fontSize: '0.9rem',
  lineHeight: 1.5,
  color: theme.palette.text.primary,
  fontFamily: 'monospace',
}));
